import { useState } from "react";
import axios from "axios";

import {
  Box,
  useColorModeValue,
  Button,
  Flex,
  Portal,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  List,
  Text,
  Center,
  Divider,
} from "@chakra-ui/react";

import { SidebarContext } from "contexts/SidebarContext";

import React from "react";

import Loader from "components/Loader";
import HistoryItem from "../../admin/checkDownloadData/components/HistoryItem";
import Navbar from "components/navbar/NavbarAdmin.js";

import Card from "components/card/Card";

import Nft1 from "../../../assets/img/nfts/Nft1.png";

import { handleRemoveFile } from "helper/UploadFilePageHelper";

import ModalAllPages from "components/pdf/ModalAllPages";
import { useNavigate } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar.js";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import routes from "routes.js";

import { SubfolderItem } from "views/upload/components/SidebarFolder";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const api_url = process.env.REACT_APP_API;

export default function ClassificationUploadFilesPage() {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { onOpen } = useDisclosure();

  const [showFilePreview, setShowFilePreview] = useState(false);
  const [filePreview, setFilePreview] = useState(null);

  const [folderData, setFolderData] = useState(null);

  const [selectFolderDrwerOpen, setSelectFolderDrwerOpen] = useState(false);

  const [selectedFolder, setSelectedFolder] = useState(null);

  const [classificationData, setClassificationData] = useState(null);

  const [classification_output_data, setClassification_output_data] =
    useState(null);

  const handleClick = () => {
    setLoading(true);
    axios
      .post(`${api_url}/document_classification_upload`, {
        files: files,
      })
      .then((response) => {
        const columnsCopy = {
          "column-1": {
            id: "column-1",
            title: "PHSP Agreement",
            elements: [],
          },
          "column-2": {
            id: "column-2",
            title: "Managed Care Contract",
            elements: [],
          },
          "column-3": {
            id: "column-3",
            title: "Assesment Worksheet Form",
            elements: [],
          },
        };
        for (const columnId in columnsCopy) {
          const column = columnsCopy[columnId];
          const entity_title = column.title;

          if (entity_title === "PHSP Agreement") {
            const filteredObjects = response.data.output.filter(
              (obj) => obj.entity_valid === "phsp_agreement"
            );

            column.elements.push(...filteredObjects);
          } else if (entity_title === "Managed Care Contract") {
            const filteredObjects2 = response.data.output.filter(
              (obj) => obj.entity_valid === "managed_care_contract"
            );

            column.elements.push(...filteredObjects2);
          } else if (entity_title === "Assesment Worksheet Form") {
            const filteredObjects3 = response.data.output.filter(
              (obj) => obj.entity_valid === "assessment_worksheet_request_form"
            );

            column.elements.push(...filteredObjects3);
          }
          // You can perform operations on the 'column' object here.
        }

        setClassification_output_data(columnsCopy);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  };

  // ---------------------------
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");

  function populateSelectFolder() {
    setLoading(true);
    axios
      .get(`${api_url}/google_bucket_folder_structure`)
      .then((response) => {
        setFolderData(response.data);
        setLoading(false);
        setSelectFolderDrwerOpen(true);
      })
      .catch((error) => console.error(error));
  }

  const handleFolderClick = (selectedFolder) => {
    setSelectedFolder(selectedFolder);

    if (
      selectedFolder.folder_contents.filter((str) => str !== "").length !== 0
    ) {
      axios
        .post(`${api_url}/google_bucket_folder_files`, {
          folder_path: selectedFolder.folder_path,
        })
        .then((response) => {
          setFiles(response.data.files);
          setSelectFolderDrwerOpen(false);
          setLoading(false);
        });
    } else {
      alert("This folder has no files");
    }
  };

  async function getFileContent(file) {
    const response = await fetch(
      `${api_url}/get_google_bucket_file?file_path=${file.file_path}`,
      {}
    );
    const data = await response.blob();
    setFilePreview(data);
    setShowFilePreview(true);
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const sourceColumn = classification_output_data[result.source.droppableId];
    const destinationColumn =
      classification_output_data[result.destination.droppableId];
    const [movedElement] = sourceColumn.elements.splice(result.source.index, 1);

    destinationColumn.elements.splice(
      result.destination.index,
      0,
      movedElement
    );

    setClassification_output_data({ ...classification_output_data });
  };

  function classifyByFolders() {
    axios
      .post(`${api_url}/classification_to_folders`, {
        output: classification_output_data,
      })
      .then((response) => {
        navigate("/storage-page");
      });
  }
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      navbarHeading="Document Classification"
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box height="85vh" mt={20} rounded={12} bg="white">
                    {classification_output_data ? (
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Box display="flex" justifyContent="end" pr={4} py={4}>
                          <Button
                            width="150px"
                            onClick={() => {
                              classifyByFolders();
                            }}
                            variant="action"
                          >
                            Next
                          </Button>
                        </Box>

                        <Box display="flex" px={4} flexDirection="row">
                          {Object.values(classification_output_data).map(
                            (column, index) => (
                              <Box
                                height="100%"
                                w="100%"
                                p={2}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                flexDirection="column"
                                key={column.id}
                                borderRight={`${
                                  index === 2 ? "" : "1px solid #d1d6de"
                                } `}
                              >
                                <Text fontWeight="bold" fontSize="md" mb="8px">
                                  {column.title}
                                </Text>
                                <Droppable droppableId={column.id}>
                                  {(provided, snapshot) => (
                                    <Box
                                      w="100%"
                                      h="73vh"
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      className="column-inner"
                                    >
                                      {column.elements.map(
                                        (elementId, index) => (
                                          <Draggable
                                            key={elementId.file_name}
                                            draggableId={elementId.file_name}
                                            index={index}
                                          >
                                            {(provided, snapshot) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="element"
                                              >
                                                <HistoryItem
                                                  name={elementId.file_name}
                                                  author={elementId.file_type}
                                                  onClickItem={() => {
                                                    getFileContent(elementId);
                                                  }}
                                                  onClickIcon={(event) => {}}
                                                  date=""
                                                  image={Nft1}
                                                  price="0.91 ETH"
                                                />
                                                {/* Element {elementId.file_name} */}
                                              </div>
                                            )}
                                          </Draggable>
                                        )
                                      )}
                                      {provided.placeholder}
                                    </Box>
                                  )}
                                </Droppable>
                              </Box>
                            )
                          )}
                        </Box>
                      </DragDropContext>
                    ) : (
                      <Flex
                        flexDirection="column"
                        gridArea={{
                          xl: "1 / 3 / 2 / 4",
                          "2xl": "1 / 2 / 2 / 3",
                        }}
                      >
                        <Card p="0px">
                          <Flex
                            align={{ sm: "flex-start", lg: "center" }}
                            justify="space-between"
                            w="100%"
                            px="22px"
                            py="18px"
                          >
                            <Button
                              width="130px"
                              onClick={() => {
                                populateSelectFolder();
                              }}
                              variant="action"
                            >
                              Select folder
                            </Button>
                            {files.length === 0 ? (
                              <></>
                            ) : (
                              <Button onClick={handleClick} variant="action">
                                Next
                              </Button>
                            )}
                          </Flex>
                          {files.map((file, index) => (
                            <HistoryItem
                              name={file.file_name}
                              author={file.file_type}
                              onClickItem={() => {
                                getFileContent(file);
                              }}
                              onClickIcon={(event) => {
                                handleRemoveFile(index, setFiles);
                                // event.stopPropagation();
                              }}
                              date=""
                              image={Nft1}
                              price="0.91 ETH"
                            />
                          ))}
                        </Card>
                      </Flex>
                    )}

                    {filePreview === null ? (
                      <></>
                    ) : (
                      <ModalAllPages
                        filePreview={filePreview}
                        setShowFilePreview={setShowFilePreview}
                        showFilePreview={showFilePreview}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}

      {folderData ? (
        <Drawer
          isOpen={selectFolderDrwerOpen}
          placement="right"
          onClose={() => {
            setSelectFolderDrwerOpen(false);
          }}
          // finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Select Folder</DrawerHeader>

            <DrawerBody>
              <List spacing={4} mt={5}>
                {folderData.sub_folders.map((subFolder, index) => (
                  <SubfolderItem
                    key={index}
                    subFolder={subFolder}
                    setSelectedFolder={setSelectedFolder}
                    onClick={() => handleFolderClick(subFolder)}
                    level={0}
                    handleFolderClick={handleFolderClick}
                  />
                ))}
              </List>
            </DrawerBody>

            <DrawerFooter>
              <Button
                variant="outline"
                mr={3}
                onClick={() => {
                  setSelectFolderDrwerOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  navigate("/storage-page");
                }}
                colorScheme="blue"
              >
                Add Files
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      ) : (
        <></>
      )}
    </>
  );
}
